import { Component } from '@angular/core';

@Component({
  selector: 'app-seguro-privado-detalle',
  templateUrl: './seguro-privado-detalle.component.html',
  styleUrls: ['./seguro-privado-detalle.component.sass'],
})
export class SeguroPrivadoDetalleComponent {}
